<script>
    import {color as Color} from 'd3-color';
    import {createEventDispatcher} from "svelte";
    import Slider from "./Slider.svelte";
    import {hex} from "./color-utilities";

    export let color;
    export let transparencyLabel = undefined;

    let colorObj = Color(color);

    let transparency = 255 - colorObj.opacity * 255;
    let hexRGB = colorObj.hex();

    const dispatch = createEventDispatcher();

    function onChange() {
        const newColor = hexRGB + hex(256 - transparency);
        dispatch('changeColor', newColor);
    }
</script>

<label>
    <span>
        Colour&nbsp;
        <input type="color" bind:value={hexRGB} on:change={onChange} />
    </span>
</label>

<label>
    <Slider bind:value={transparency} min={1} max={255} step={1} on:change={onChange}>
        { transparencyLabel || 'Transparency' }
    </Slider>
</label>

<style>
    label {
        display: inline-block;
        margin-right: 0.5em;
    }

    label > span {
        vertical-align: middle;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
    }
</style>

